import { QuoteUnderwritingTaskSearchResponse, QuoteUnderwritingTaskPatchRequestBody } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export type UnderwritingTaskDetailsItems = QuoteUnderwritingTaskSearchResponse['items'];
export type UnderwritingIssue = ArrayItem<UnderwritingTaskDetailsItems>;

export type IssueStatus = NonNullable<QuoteUnderwritingTaskPatchRequestBody['status']>;

export const UnderwritingRuleIds = {
  CustomerMatchNotConfirmed: 'cmb8broxr0000q7tu2h5qeeew',
  DuplicateCustomerMatch: 'cmlbcggso0000ohtuhu09en37',
  Other: 'cl1ff96gn00iowcfgc133azze',
} as const;
